<template>
  <div class="mm-page-main" v-loading="loading">
    <div class="page-header">
      <div class="page-title">添加賣出交易</div>
      <div @click="pageback" class="page-back">
        <svg class="icon svg-icon" aria-hidden="true">
          <use xlink:href="#icon-back"></use>
        </svg>
      </div>
    </div>
    <businessadd  @submit="pageback"></businessadd> 
  </div>
</template>

<script>
import businessadd from '@/components/SellBusinessAdd.vue';
export default {
  components: {
    businessadd
  },
  data () {
    return {
      loading:false,
    };
  },
  methods: {
    pageback () {
      this.$router.go(-1);
    },
  }

};
</script>
<style scoped>
</style>
